import axiosInstance from '../AxiosInstance';

const API_URL = '/platform/announcements';

class AnnouncementApiService {

    pageable(payload) {
        return axiosInstance.post(`${API_URL}/pageable`, payload);
    }

    findAll() {
        return axiosInstance.get(`${API_URL}`);
    }

    findById(id) {
        return axiosInstance.get(`${API_URL}/${id}`);
    }

    create(data) {
        return axiosInstance.post(`${API_URL}`, data);
    }

    update(id, data) {
        return axiosInstance.patch(`${API_URL}/${id}`, data);
    }

    remove(id) {
        return axiosInstance.delete(`${API_URL}/${id}`);
    }

    findActive() {
        return axiosInstance.get(`${API_URL}/active`);
    }

    uploadImage(file) {
        const formData = new FormData();
        formData.append('file', file);
        return axiosInstance.post(`${API_URL}/upload-image`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    }

    downloadImage(id) {
        return axiosInstance.get(`${API_URL}/${id}/image`, { responseType: 'arraybuffer' });
    }
}

export default new AnnouncementApiService();
